import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { EPointsBanner } from 'components/common/EPointsBanner/EPointsBanner';
import { MainDealersGroupBanner } from 'components/common/MainDealersGroupBanner/MainDealersGroupBanner';
import { MAIN_DEALERS_GROUP } from 'constants/dealersGroup';
import { getDealersGroupName, shouldShowBanner } from './helpers';

export const useApplicationsBannerPresenter = () => {
  const { id: userId } = useSelector((state) => state.user);
  const { dealer: activeDealer } = useSelector((state) => state.activeDealer);
  const { isEPointsDigitalDealMember } = useSelector((store) => store.ePoints);

  const getApplicationsBanner = useCallback(() => {
    // Баннер для основных групп дилеров
    const mainDealersGroupActivated = true;
    // Перевести в false, если захотят скрыть баннер, для добавления нового баннера с новой группой, вместо старого - создать новую переменную, например digitalDealDealersGroupActivated и соответствуюший блок с условием, которое будет возвращать новый баннер, например return <DigitalDealDealersGroupBanner />

    if (activeDealer?.id && activeDealer?.dealerGroups?.length > 0 && mainDealersGroupActivated) {
      const groupName = getDealersGroupName(activeDealer.dealerGroups, MAIN_DEALERS_GROUP);

      if (groupName && shouldShowBanner(groupName, userId)) {
        return <MainDealersGroupBanner />;
      }
    }

    // Баннер программы лояльности ePoints
    if (
      !activeDealer?.epointsDigitalDealMember &&
      typeof isEPointsDigitalDealMember === 'boolean' &&
      isEPointsDigitalDealMember
    ) {
      return <EPointsBanner />;
    }

    return null;
  }, [activeDealer, isEPointsDigitalDealMember]);

  return {
    getApplicationsBanner,
  };
};
